export class Blog {
  constructor() {
    this.search_form = document.querySelector('#filter-blog');
    this.search_result_wrapper = document.querySelector('[blog-content-one]');
    this.pagination_wrapper = document.querySelector('#pagination');
    this.pagination_input = document.querySelector('#current_page');
    this.pagination_buttons = document.querySelectorAll('[data-pagination-page]');
    this.loader = `<div></div><div class="block text-center flex-1"><div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div><div></div>`;
    this.init();
  }

  init() {
    if(!this.search_form) {
      return false;
    }

    this.formAutoSend();
    this.send_one();
    this.onChangeSelect();
  }

  handlePaginationClick() {
    this.pagination_buttons = document.querySelectorAll('[data-pagination-page]');

    if(!this.pagination_buttons) {
      return false;
    }
    this.pagination_buttons.forEach( button => button.addEventListener('click', () => { this.pagination_input.value = button.dataset.paginationPage;
      this.send_one(true);
    }))
  }

  formAutoSend() {
    const inputs = this.search_form.querySelectorAll('input');
    inputs.forEach(input => input.addEventListener('click', () => {
      this.pagination_input.value = 1;
      this.send_one();
    }))
  }

  addLoader() {
    this.search_result_wrapper.innerHTML = this.loader;
  }

  removeLoader() {
    this.search_result_wrapper.innerHTML = '';
  }

  scrollToTop() {
    let top = document.querySelector('[blog-content-one]').offsetTop;
    window.scroll({top: top, left: 0, behavior: 'smooth'});
  }

  onChangeSelect() {
    const buttons = this.search_form.querySelectorAll('button');
    buttons.forEach((button) =>
      button.addEventListener('click', (e) => {
        this.pagination_input.value = 1;
        if (button.classList.contains('category-filter')) {
          buttons.forEach((f) => f.classList.remove('js-active-category'));
          e.target.classList.toggle('js-active-category');
        } else {
          buttons.forEach((f) => f.classList.remove('js-active-tag'));
          e.target.classList.toggle('js-active-tag');
        }
        this.send_one();
      })
    );
  }

  send_one(scroll = false) {
    this.search_results_wrapper = this.loader;

    const category_btn = document.querySelector('.js-active-category');
    const tag_btn = document.querySelector('.js-active-tag');

    const ajax_form_data = new FormData(this.search_form);

    if (category_btn) {
      const category_value = category_btn.dataset.filter;
      ajax_form_data.append('category', category_value);
    }

    if (tag_btn) {
      const tag_value = tag_btn.dataset.filter;
      ajax_form_data.append('tag', tag_value);
    }

    ajax_form_data.append('action', 'filter_blog_one');

    this.addLoader();

    fetch(ajax_object.ajax_url, {
      method: 'post',
      body: ajax_form_data,
    })
      .then((res) => res.text())
      .then((res) => {
        this.search_result_wrapper.innerHTML = res;
        this.handlePaginationClick();
        if(scroll) {
            this.scrollToTop();
        }
      });
  }
}

const _blog = new Blog();
_blog.init();
